define('controllers/hotelportal',['require'],function(require) {
    return function() {
        $("#btnQuestion").on("click", function () {
            $("#successMsg").hide();
            $("#QuestionPanel").slideToggle('fast');
        });

        $("#CancelMessage").on("click", function () {
            $("#QuestionPanel").slideUp('fast');
        });
    };
});

